// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News } from '../interfaces/news.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { DataProcessingService } from './data-prcessing.service';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class NewsService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('news');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getList(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<News>> {
    return this.http.get<any>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }


  getAdminListData(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<News>> {
    return this.http.get<any>(this.apiUrl + '/list', { params: this.dataProcess.fitlerParams(params) });
  }

  changeSort(news_id: number, direction: 'UP' | 'DOWN'): Observable<any> {
    const url = `${this.apiUrl}/sort`;
    return this.http.get<any>(url, {
      params: {
        news_id: news_id.toString(),
        direction
      }
    });
  }

  deleteFile(uuid: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/delete-file/${uuid}`);
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/file-upload`, formData);
  }


  getNews(id: number): Observable<News> {
    return this.http.get<News>(`${this.apiUrl}/${id}`);
  }

  updateNews(id: number, data: News): Observable<News> {
    return this.http.put<News>(`${this.apiUrl}/${id}`, data);
  }


  createNews(data: Partial<News>): Observable<News> {
    return this.http.post<News>(this.apiUrl, data);
  }

  deleteNews(NewsId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${NewsId}`);
  }


}